import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  menuItemText: {
    marginRight: '4px',
  },
  menuItemIcon: {
    position: 'relative',
    top: '2px',
  },
  activeChip: {
    background: '#7BC67E',
  },
  errorChip: {
    marginRight: '0.5rem',
    marginBottom: '0.5rem',
  },
  unableToAcceptPaymentsChip: {
    background: '#F88078',
    marginRight: '0.5rem',
    marginBottom: '0.5rem',
  },
  payoutsOnHoldChip: {
    background: '#FFB547',
    marginRight: '0.5rem',
    marginBottom: '0.5rem',
  },
  stripeSetupIncompleteChip: {
    background: '#E0E0E0',
    marginRight: '0.5rem',
    marginBottom: '0.5rem',
  },
  errorIcon: {
    color: '#000000DE',
  },
  warningBox: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: 8,
  },
  chargesDisabledWarning: {
    backgroundColor: '#feecea',
  },
  payoutsDisabledWarning: {
    backgroundColor: '#f8f7e2',
  },
  detailsNotSubmittedWarning: {
    backgroundColor: '#FAFAFA',
  },
  cardHeader: {
    borderBottom: '1px solid #E0E0E0',
  },
}))
